// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueAuthenticate from 'vue-authenticate'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VuePromiseBtn from 'vue-promise-btn'
import VueSelect from 'vue-select'
import VueScrollTo from 'vue-scrollto'
import VueLoading from 'vue-loading-overlay'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faEdit, faArrowDown, faPlusSquare, faSave, faTimes, faQuestionCircle, faTrash
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ClickConfirm from '@/components/ClickConfirm'
import ToggleButton from 'vue-js-toggle-button'

import App from './App'
import router from './router'
import store from './store'

import 'vue-promise-btn/dist/vue-promise-btn.css'
import 'vue-loading-overlay/dist/vue-loading.min.css'

import { USER_REQUEST } from '@/store/actions/user'
import { AUTH_LOGOUT } from '@/store/actions/auth'

library.add(faEdit, faArrowDown, faPlusSquare, faSave, faTimes, faQuestionCircle, faTrash)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('v-select', VueSelect)

Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VuePromiseBtn)
Vue.use(VueScrollTo)
Vue.use(VueLoading)
Vue.use(ClickConfirm)
Vue.use(ToggleButton)

Vue.use(VueAuthenticate, {
  baseUrl: process.vars.BACKEND_HOST, // Your API domain
  tokenName: 'token',
  storageType: 'memoryStorage',
  providers: {
    kaeuferportal: {
      name: 'kaeuferportal',
      url: '/api/auth/kaeuferportal',
      clientId: process.vars.AUTH_CLIENT_ID,
      redirectUri: `${window.location.protocol}//${window.location.host}/auth/callback`,
      authorizationEndpoint: `${process.vars.AUTH_HOST}/oauth/authorize`,
      oauthType: '2.0',
      popupOptions: { width: 1100, height: 645 }
    }
  },
  bindRequestInterceptor: function () {},
  bindResponseInterceptor: function () {}
})
Vue.config.productionTip = false
Vue.http.options.root = process.vars.BACKEND_HOST
Vue.http.interceptors.push(function (request) {
  const loading = Vue.$loading.show()

  return function (response) {
    loading.hide()
    if (response.status === 401) {
      store.dispatch(AUTH_LOGOUT).then(() => {
        router.replace('/login')
      })
    }
  }
})

Vue.datetime_format_options = {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
}

Vue.assignmentTermStatuses = {
  active: 'active',
  paused: 'paused',
  inactive: 'inactive'
}

Vue.dates = {
  generalFormat: 'DD.MM.YYYY'
}

Vue.defaultDatepickerOptions = {
  firstDayOfWeek: 1,
  clearable: false,
  lang: 'en',
  format: Vue.dates.generalFormat,
  editable: false,
  notBefore: new Date()
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated
    }
  },
  beforeMount: function () {
    if (this.isAuthenticated) {
      const token = this.$store.state.auth.token
      Vue.http.headers.common['Authorization'] = `Bearer ${token}`
      this.$store.dispatch(USER_REQUEST, token)
    }
  }
})
